<div mat-dialog-content>
	<p>{{ message }}</p>
</div>
<div mat-dialog-actions fxLayout fxLayoutAlign="end">
	<button
		*ngIf="showFailureButton"
		mat-button
		(click)="failureClose()"
		[color]="failureButtonColor"
	>
		{{ failureButtonText }}
	</button>
	<button
		mat-button
		(click)="successClose()"
		[color]="successButtonColor"
		cdkFocusInitial
	>
		{{ successButtonText }}
	</button>
</div>
